"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DateFormat = void 0;
var DateFormat;
(function (DateFormat) {
    DateFormat["D_MM"] = "d.MM";
})(DateFormat || (DateFormat = {}));
exports.DateFormat = DateFormat;
